export const TOOL_STATUS = [ "open", "falsepositive", "confirmed",  "acceptrisk", "mitigated", "suppressed", "triage", "inprogress", "controlled"];

export const TOOL_STATUS_VOCABULARY_MAP = {
  "open": "open",
  "falsepositive": "falsePositive",
  "confirmed": "confirmed",
  "acceptrisk": "acceptRisk",
  "mitigated": "mitigated",
  "suppressed": "suppressed",
  "triage": "triageStatus",
  "inprogress": "inProgressStatus",
  "controlled": "controlledStatus"
};

export const TOOL_STATUS_MAPPING_SUPPORT = ['Blackduck Hub', 'Coverity'];

export const PROJECT_VERSION_PHASES_SUPPORT = ['Blackduck Hub'];

export const STORAGE_USAGE_SUPPORT_TOOL = ['Blackduck Hub'];

export const RISK_REPORT_SUPPORT_TOOL_NAME = ['Blackduck Hub'];

export const API_PHASE_TOOL_NAME = {
    'Blackduck Hub': 'blackduck'
}

export const STORAGE_SUPPORT_TOOL_NAME = {
    'Blackduck Hub': 'blackduck'
}

export const TOOL_STORAGE_USAGE_SUPPORTS = {
    "SOURCE_CODE": "Source Code",
    "STATICALLY_LINKED": "Statically Linked",
    "DYNAMICALLY_LINKED": "Dynamically Linked",
    "SEPARATE_WORK": "Separate Work",
    "MERELY_AGGREGATED": "Merely Aggregated",
    "IMPLEMENTATION_OF_STANDARD": "Implementation of Standard",
    "PREREQUISITE": "Prerequisite",
    "DEV_TOOL_EXCLUDED": "Dev. Tool/Excluded",
    "UNSPECIFIED": "Unspecified"
}

export const PROJECT_VERSION_PHASES = {
    "RELEASED": "Released",
    "DEVELOPMENT": "In Development",
    "PRERELEASE": "Pre-Release",
    "ARCHIVED": "Archived",
    "DEPRECATED": "Deprecated",
    "PLANNING": "In Planning"
}

export const  EXCLUDE_SCAN_REPORT_SUPPORTED_TOOL = ['Github Code Scan'];

export const EXCLUDE_WORK_FLOW_TOOL_NAME = {
    'Github Code Scan': 'github'
}

export const MODIFY_STATUS_NAME_TOOLS = ['BLACKDUCK_HUB']

export const DEFAULT_STATUS_MAPPING = {
    'BLACKDUCK_HUB': {
        acceptrisk: ["IGNORED"],
        mitigated: ["REMEDIATION_COMPLETE", "MITIGATED", "PATCHED"],
        open: ["NEW", "REMEDIATION_REQUIRED", "NEEDS_REVIEW"],
    },
    'COVERITY': {
        acceptrisk: ["Intentional"],
        open: ["Unclassified", "Bug", "Pending"],
        falsepositive: ["False Positive"]
    }
}

    export const DEFAULT_STATUS_MAPPING_NEW = {
    'BLACKDUCK_HUB': {
        acceptrisk: [
             "IGNORED"
        ],
        mitigated: [
            "REMEDIATION_COMPLETE",
            "MITIGATED"
        ],
        open: [
            "NEW",
            "REMEDIATION_REQUIRED",
            "UNDER_INVESTIGATION"
        ],
        triage: [
            "NEEDS_REVIEW"
        ],
        controlled: [
            "PATCHED"
        ],
        falsepositive: [
            "KNOWN_NOT_AFFECTED"
        ],
        confirmed: [
            "KNOWN_AFFECTED"
        ]
    },
    'COVERITY': {
      suppressed: [
        "Intentional"
      ],
      open: [
        "Bug",
        "Unclassified"
      ],
      falsepositive: [
        "False Positive"
      ],
      triage: [
        "Pending"
      ]
    }
  };

export const STATUS_OPTIONS = {
    BLACKDUCK_HUB: [
      "NEW",
      "PATCHED",
      "REMEDIATION_REQUIRED",
      "REMEDIATION_COMPLETE",
      "MITIGATED",
      "IGNORED",
      "NEEDS_REVIEW",
      "UNDER_INVESTIGATION",
      "KNOWN_AFFECTED",
      "KNOWN_NOT_AFFECTED"
    ],
  
    COVERITY: [
      "False Positive",
      "Bug",
      "Intentional",
      "Pending",
      "Unclassified"
    ]
  };

export const ARCHIVED_SUPPORTED_TOOL = ['Mend', 'Fortify', 'Mend.io'];

export const FINDING_STATUS_MAPPING_SUPPORT =['HackerOne']

export const CONFIDENCE_FINDINGS_SUPPORT = ['Contrast Security'];

export const DEFAULT_CONFIDENCE_LEVEL = ["High", "Medium", "Low"];

export const FINDINGS_CONFIDENCE_OPTIONS = ["High", "Medium", "Low"];

export const TOOL_RISK_SUPPORTS = {
    "SECURITY_RISK": "Security Risk",
    "LICENSE_RISK": "License Risk"
}

export const SCAN_EXECUTE_SUPPORTED_TOOL = ['Edgescan']

export const SEVERITY_FILTER_SUPPORT_TOOL = ['JFrog Xray']; 